/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemixContestUpdateNotificationActionData
 */
export interface RemixContestUpdateNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof RemixContestUpdateNotificationActionData
     */
    eventId: string;
    /**
     * 
     * @type {string}
     * @memberof RemixContestUpdateNotificationActionData
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof RemixContestUpdateNotificationActionData
     */
    entityUserId: string;
    /**
     * 
     * @type {string}
     * @memberof RemixContestUpdateNotificationActionData
     */
    commentId: string;
}

/**
 * Check if a given object implements the RemixContestUpdateNotificationActionData interface.
 */
export function instanceOfRemixContestUpdateNotificationActionData(value: object): value is RemixContestUpdateNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "eventId" in value && value["eventId"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;
    isInstance = isInstance && "entityUserId" in value && value["entityUserId"] !== undefined;
    isInstance = isInstance && "commentId" in value && value["commentId"] !== undefined;

    return isInstance;
}

export function RemixContestUpdateNotificationActionDataFromJSON(json: any): RemixContestUpdateNotificationActionData {
    return RemixContestUpdateNotificationActionDataFromJSONTyped(json, false);
}

export function RemixContestUpdateNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixContestUpdateNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventId': json['event_id'],
        'entityId': json['entity_id'],
        'entityUserId': json['entity_user_id'],
        'commentId': json['comment_id'],
    };
}

export function RemixContestUpdateNotificationActionDataToJSON(value?: RemixContestUpdateNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_id': value.eventId,
        'entity_id': value.entityId,
        'entity_user_id': value.entityUserId,
        'comment_id': value.commentId,
    };
}

